
import { Button } from "@/components/ui/button";
import { Dialog } from "@radix-ui/react-dialog";
import React from "react";

type DeleteArticleDialogProps = {
  open: boolean;
  article: any;
  onClose: () => void;
  onDelete: (id: number | string) => void;
};

const DeleteArticleDialog: React.FC<DeleteArticleDialogProps> = ({
  open, article, onClose, onDelete
}) => (
  <Dialog open={open} onOpenChange={(value) => !value && onClose()}>
    {open && (
      <div className="fixed inset-0 flex items-center justify-center z-50 bg-black/10">
        <div className="bg-white rounded-lg shadow-lg p-6 w-[90vw] max-w-md">
          <h3 className="text-lg font-bold mb-2">Delete Article</h3>
          <p className="mb-4">Are you sure you want to delete
            <span className="font-semibold ml-1">{article?.title}</span>?<br />
            This action cannot be undone.
          </p>
          <div className="flex justify-end gap-2">
            <Button
              variant="outline"
              onClick={onClose}
            >
              Cancel
            </Button>
            <Button
              className="bg-red-500 hover:bg-red-600 text-white"
              onClick={() => onDelete(article?.id)}
            >
              Delete
            </Button>
          </div>
        </div>
      </div>
    )}
  </Dialog>
);

export default DeleteArticleDialog;
